import { createQueryKeys } from 'utils/react-query-utils';

export const knowledgeKeys = createQueryKeys('knowledge', (createKey) => ({
  territories: createKey('territories'),
}));
